// extracted by mini-css-extract-plugin
export default {"fill":"button_fill__Wpuf5","button":"button_button__rr3yo"};